<template>
  <div style="height: 700px;">
    <div style="height: 650px;overflow: auto">

      <div>
        <el-input v-model="input" placeholder="搜索" @input="finduser" style="width: 200px" size="mini"></el-input>
      </div>
      <el-row>
        <el-col :span="6" v-for="(item,index) in userlist" :key="'se'+index" v-if="item.name" style="margin-top: 10px">

          <el-checkbox border v-if="mode=='multi'" class="select_user" :disabled="item.isadmin==1 && type=='role'" v-model="item.select"
                       @change="select_user">{{ item.name }} <span v-if="item.department_name">【{{ item.department_name }}】</span>
          </el-checkbox>
          <el-radio border v-else class="select_user" :disabled="item.isadmin==1 && type=='role'" v-model="select_user_id" :label="item._id"
                    @change="select_user(item)">{{ item.name }} <span v-if="item.department_name">【{{ item.department_name }}】</span>
          </el-radio>

        </el-col>
      </el-row>
    </div>
    <div style="height: 50px;text-align: center">

      <el-button type="primary" size="mini" style="width: 200px" @click="clear"> 确定</el-button>

    </div>
  </div>
</template>

<script>
import u from "../../../assets/js/util";

export default {
  props: ["list", "admin", "type", "mode"],
  name: "select_user",
  data() {
    return {
      input: "",
      userlist: [],
      yuanlist: [],
      select_user_id: ""
    }
  },
  async mounted() {


    try {


      var list = await u.post("users", "get_userlist",
        {
          "table": "users",
          page: 1,
          size: 999,
          where: {grouid: userinfo.grouid, is_delete: 0, distable: 0}
        })

      list[0].forEach((item) => {

        item.select = false
        if (this.list) {
          for (var i = 0; i < this.list.length; i ++) {
            if (item._id == this.list[i]._id) {
              item.select = true
              this.select_user_id = item._id
            }
          }
        }
      })
      this.yuanlist = list[0]

      this.userlist = this.yuanlist
    } catch (e) {

    }
  },
  methods: {

    finduser(e) {

      if (!this.input) {

        this.userlist = this.yuanlist
        return
      }
      this.userlist = []

      for (var i = 0; i < this.yuanlist.length; i ++) {
        var obj = this.yuanlist[i];

        if (obj.name.indexOf(this.input) > - 1) {
          this.userlist.push(obj)

        }

      }
    },
    clear() {

      this.$emit("close", "")
    },
    select_user(e) {
      var userlist = []
      if (e !== true && e !== false) {
        this.$emit("success", [{name: e.name, _id: e._id}])
        return
      }

      for (var i = 0; i < this.userlist.length; i ++) {
        if (this.userlist[i].select == true) {
          userlist.push({name: this.userlist[i].name, _id: this.userlist[i]._id})
        }
      }
      this.$emit("success", userlist)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/util/select_user.vue